/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Sample_HintInputs */

const cs_builder_sample_hint = /** @type {(inputs: Builder_Sample_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neutrální náhledová data — bez brandingu tenanta. Úpravy ovlivní jen tento náhled.`)
};

const en_builder_sample_hint = /** @type {(inputs: Builder_Sample_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neutral preview values — no tenant branding. Edits only affect this preview.`)
};

/**
* | output |
* | --- |
* | "Neutral preview values — no tenant branding. Edits only affect this preview." |
*
* @param {Builder_Sample_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_sample_hint = /** @type {((inputs?: Builder_Sample_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Sample_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_sample_hint(inputs)
	return cs_builder_sample_hint(inputs)
});